import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { workAdvisoryKeys } from "@/lib/query-keys";
import type { WorkAdvisoryReportData } from "@/types/workadvisory";

/** Genera el borrador de un período a pedido. Sin fecha, la última semana cerrada. */
export function useGenerateWorkAdvisoryDraft() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { organizationId: string; periodStart?: string }) =>
      fetchToBackend("/admin/work-advisory/reports", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: workAdvisoryKeys.all }),
  });
}

/** Guarda las correcciones humanas sobre el informe entero. */
export function useSaveWorkAdvisoryDraft() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      reportId,
      data,
    }: {
      reportId: number;
      data: WorkAdvisoryReportData;
    }) =>
      fetchToBackend(`/admin/work-advisory/reports/${reportId}`, {
        // PUT y no PATCH: se manda el `data` entero (es un reemplazo), y PATCH
        // ni siquiera está en los métodos permitidos por CORS en `app.ts`.
        method: "PUT",
        body: JSON.stringify({ data }),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: workAdvisoryKeys.all }),
  });
}

/** Publica: es el acto que lo hace visible para el cliente. */
export function usePublishWorkAdvisoryReport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (reportId: number) =>
      fetchToBackend(`/admin/work-advisory/reports/${reportId}/publish`, {
        method: "POST",
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: workAdvisoryKeys.all }),
  });
}
